import React from 'react'

import { AppOfficesBlock } from '@components'
import { BACKEND_APIS } from '@constants'
import {AutocompleteAjaxSeeker} from "@ui-seeker/core";


export default function AppOfficesAutocomplete({ ...props }) {
	return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		label="Offices"
		placeholder="All offices"
		formatOptionLabel={({ label, office_type, country }) => <AppOfficesBlock name={label} type={office_type} country={country}/>}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/office`}
		{...props}
	/>
}